/* GASSISA
=========================================================================================
* Descripción: Modal de input box
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 29/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import { Button, Dialog, DialogActions, IconButton, Typography, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Fragment, useState } from "react";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";

export default function SizeSoftXModalInputBox({
    id,
    open,
    maxWidth,
    title,
    success,
    success2,
    hideSuccess,
    hideCancel,
    disableSuccess,
    cancel,
    form,
    onSuccess,
    onSuccess2,
    onCancel,
    onClose,
    children,
    color
}) {
    const { theme } = useConfiguracion();
    const [barcode, setBarcode] = useState(""); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (onSuccess) {
            await onSuccess(barcode); // Pasamos el valor al callback
        }
    };

    const handleClose = (e, reason) => {
        if (reason === "backdropClick") return;
        onClose();
    };

    const handleKeyPress = (e) => {
        return; //Deshabilitado de momento
        if (e.key === "Enter") {
            e.preventDefault();
            if (onSuccess) onSuccess(barcode); // Enviar también al presionar Enter
        }
    };

    return (
        <Dialog
            id={id}
            className="sizesoftx-modal"
            open={open}
            onClose={handleClose}
            maxWidth={!maxWidth ? "sm" : maxWidth}
            fullWidth
            scroll="body"
            PaperProps={{
                variant: "elevation",
                style: { overflowY: "initial" },
            }}
            BackdropProps={{
                style: { backgroundColor: "rgba(0, 0, 0, 0.4)" },
            }}
        >
            <div
                className="title-container"
                style={{
                    backgroundColor: color ? color : theme.palette.secondary.main,
                    borderRadius: "4px 4px 0px 0px"
                }}
            >
                <div className="text-content">
                    <Typography variant="h6" color="white">
                        {title}
                    </Typography>
                </div>
                <Tooltip style={{ margin: 10 }}>
                    <span>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </div>

            {/* --- CONTENIDO --- */}
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <div className="content">
                    {children}
                    {/* NUEVO INPUT PARA EL CÓDIGO */}
                    <TextField autoComplete="off"
                        autoFocus
                        fullWidth
                        label="Ingrese su dato"
                        variant="outlined"
                        value={barcode}
                        onChange={(e) => setBarcode(e.target.value)}
                        onKeyPress={handleKeyPress}
                        style={{ marginTop: 15 }}
                    />
                </div>

                {/* --- BOTONES --- */}
                <DialogActions>
                    {!hideCancel && (
                        <Button color="inherit" onClick={!onCancel ? onClose : onCancel}>
                            {!cancel ? "Cancelar" : cancel}
                        </Button>
                    )}
                    {!hideSuccess && (
                        <Fragment>
                            <Button type="submit" disabled={disableSuccess}>
                                {!success ? "Confirmar" : success}
                            </Button>
                            {success2 && (
                                <Button onClick={!onSuccess2 ? () => { } : () => onSuccess2(barcode)} disabled={disableSuccess}>
                                    {!success ? "Confirmar" : success2}
                                </Button>
                            )}
                        </Fragment>
                    )}
                </DialogActions>
            </form>
        </Dialog>
    );
}
